import API from 'utils/API';
import http from 'utils/http';

// 重置invite码
export function resetInvite(inviteCode: string) {
    return http.put(API.MS.invitation.reset(), { inviteCode }, { useJson: true });
}

// 获取邀请列表
export function getInvitationList(params) {
    return http.get(API.OAUTH.invitation.list(), { params });
}
